// components/PitchDeck/07_BusinessModel.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function BusinessModel() {
    return (
        <div className="min-h-screen flex items-center bg-white py-20">
            <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    Business Model
                </h2>
                <p className="text-3xl font-semibold text-[#4285F4] mb-8">
                    Recurring + High-Margin Services
                </p>
                <div className="grid md:grid-cols-3 gap-8">
                    <div className="bg-blue-50 p-10 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">Subscriptions</h3>
                        <p className="text-xl">Monthly or annual plans</p>
                        <p className="text-3xl font-bold mt-6">₦45k–500k/month</p>
                    </div>
                    <div className="bg-blue-50 p-10 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">One-Time Fees</h3>
                        <p className="text-xl">Onboarding & training packages</p>
                        <p className="text-3xl font-bold mt-6">₦150k–350k+</p>
                    </div>
                    <div className="bg-blue-50 p-10 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">Projected Break-Even</h3>
                        <p className="text-xl">16–18 customers</p>
                        <p className="text-3xl font-bold mt-6">USD 800–1,200/month burn</p>
                    </div>
                </div>
                <p className="mt-16 text-2xl font-bold">
                    Hybrid model: Predictable recurring revenue + upfront cash from services.
                </p>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/competition">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}